import { render, staticRenderFns } from "./Leave.vue?vue&type=template&id=1a56e81e&scoped=true"
import script from "./Leave.vue?vue&type=script&lang=js"
export * from "./Leave.vue?vue&type=script&lang=js"
import style0 from "./Leave.vue?vue&type=style&index=0&id=1a56e81e&prod&scoped=true&lang=css"
import style1 from "./Leave.vue?vue&type=style&index=1&id=1a56e81e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a56e81e",
  null
  
)

export default component.exports